import { ITemplateFieldGroup } from '@/types/templates';
import { TemplateFieldGroupEnum } from '@/types/template-field-group.enum';

export interface IPresetFields {
    presetName: string;
    color: string;
    fields: Set<string>;
    forPassport?: boolean;
}

export const deprecatedFields = new Set([
    'direction',
    'subDirection',
    'subSubDirection',
    'userUploadedFiles',
    'instructionsTemplates',
    'asiGoalLeaderComment',

    'presentations',
    'economicEffect',
    'legalNumber',
    'problemSolve',
    'participantsAndTheirRoles',
    'coFinancing',
    'effectDescription',
    'country',
    'city',
    'applicantCategory',
    'applicantFirstName',
    'applicantLastName',
    'applicantMiddleName',
    'applicantBirthday',
    'applicantCity',
    'applicantCountry',
    'phone',
    'email',
    'gender',
    'education',
    'managerFirstName',
    'managerLastName',
    'managerMiddleName',
    'managerPhone',
    'managerEmail',
    'contactLastName',
    'contactFirstName',
    'contactMiddleName',
    'contactPhone',
    'contactMail',
    'participantLastName',
    'participantFirstName',
    'participantMiddleName',
    'participantCountry',
    'participantCity',
    'participantPhone',
    'participantMail',
    'ownerLastName',
    'ownerFirstName',
    'ownerMiddleName',
    'ownerPosition',

    'iAmLeader',
    'leaderEmail',
    'leaderLastName',
    'leaderFirstName',
    'leaderMiddleName',
    'leaderPhone',
    'leaderEmail',
    'leaderIdLink',
    'leaderRegion',
    'leaderResume',
    'leaderPhoto',
    'leaderSocials',
    'leaderAge',
]);

export const deprecatedPassportFields = new Set([
    'direction',
    'subDirection',
    'subSubDirection',
    'isParticipantOpenForAll',
    'nationalInclusiveAgreementIsFilled',
    'nationalInclusiveAgreement',

    'presentation',
    'businessPlan',
    'finansModel',
    'budget',
    'feedbackFiles',
    'awards',
    'cardCover',
    'userUploadedFiles',
    'subjectApplicationForParticipantInCoolCountry',
    'subjectApplicationProcessInfo',
    'infoAboutDevelopTourism',
    'listOfEducationOrganisations',
    'applicationForInclusionInCoolCountry',
    'parentConsentToParticipate',
    'tourOperatorsList',
    'displayObjectsList',
    'representativesList',
    'specialistsList',
    'consentToProcessingPersonalData',
    'consentToProcessingAndDistributionPhoto',
    'teamCreationDeclaration',
    'teamMembers',

    'iAmLeader',
    'leaderEmail',
    'leaderLastName',
    'leaderFirstName',
    'leaderMiddleName',
    'leaderPhone',
    'leaderEmail',
    'leaderIdLink',
    'leaderRegion',
    'leaderResume',
    'leaderPhoto',
    'leaderSocials',
    'leaderAge',
]);

export const passportFields = [
    'projectPartners',
    'expertiseResult',
    'workTime',
    'expectResult',
    'supportResult',
    'targetParameters',
    'organizationAdditionalInfo',
    'additionalInfo',
    'preview',
];

export const fieldGroups: ITemplateFieldGroup[] = [
    {
        name: TemplateFieldGroupEnum.PASSPORT,
        fields: passportFields
    },
    {
        name: TemplateFieldGroupEnum.GENERAL,
        fields: [
            'projectName',
            'direction',
            'subDirection',
            'subSubDirection',
            'auditory',
            'goals',
            'objectives',
            'socialEffect',
            'problem',
            'description',
            'product',
            'advantages',
            'businessModel',
            'websites',
            'stage',
            'marketAnalysis',
            'partners',
            'potential',
            'organizationWebsite',
            'nationalTargets',
            'nationalProjects',

            'benefits',
            'resursObesp',
            'whereAprob',
            'difficulties',
            'requestedAmount',
            'beneficiaries',

            'currentRegions',
            'orgName',
            'orgShortName',
            'orgOGRN',
            'orgINN',
            'orgLegalAddress',
            'orgFactAddress',
            'teamMembers',
            'teamDescription',
            'asiGoals',
            'videoLinks',
            'territorialImplementation',
            'implementationCountries',
            'locality',
            'implementationPeriod',
            'isInvestment',
            'applicantINN',
            'identityDocument',
            'registrationAddress',

            'deyatelnost',
            'howHeardAboutSelection',
            'practiceDescription',
            'regulatoryChanges',
            'isCurrentExporter',
            'currentlyExportedGoods',
            'currentExportCountries',
            'asiGoalLeaderComment',
            'practiceOwner',
            'regionalAuthority',
            'practiceModel',
            'artifacts',
            'legalStatus',

            'customTextField1',
            'customTextField2',
            'customTextField3',
            'customTextField4',
            'customTextField5',
            'customTextField6',
            'customTextField7',
            'customTextField8',
            'customTextField9',
            'customTextField10',
            'customBooleanField1',
            'customBooleanField2',
            'customBooleanField3',
            'customBooleanField4',
            'customBooleanField5',
            'customBooleanField6',
            'customBooleanField7',
            'customBooleanField8',
            'customBooleanField9',
            'customBooleanField10',

            'isParticipantOpenForAll',
            'nationalInclusiveAgreementIsFilled',
            'instructionsTemplates',
        ],
    },
    {
        name: TemplateFieldGroupEnum.UPLOAD,
        fields: [
            'presentation',
            'businessPlan',
            'finansModel',
            'budget',
            'feedbackFiles',
            'awards',
            'cardCover',
            'subjectApplicationForParticipantInCoolCountry',
            'subjectApplicationProcessInfo',
            'infoAboutDevelopTourism',
            'listOfEducationOrganisations',
            'applicationForInclusionInCoolCountry',
            'parentConsentToParticipate',
            'tourOperatorsList',
            'displayObjectsList',
            'representativesList',
            'specialistsList',
            'consentToProcessingPersonalData',
            'consentToProcessingAndDistributionPhoto',
            'teamCreationDeclaration',
            'nationalInclusiveAgreement',
        ]
    },
    {
        name: TemplateFieldGroupEnum.LEADER,
        fields: [
            'leaderEmail',
        ]
    }
];

export const groupedFields: Set<string>[] = [];

export const dependentFields: Map<string, string> = new Map([]);

export const alwaysVisibleFields = new Set([
    'projectName',
]);

export const fieldsInShowcase = new Set([
    'projectName',
    'description',
    'problem',
    'product',
    'goals',
    'expectResult',
    'orgName',
    'orgShortName',
    'orgLegalAddress',
    'orgFactAddress',
    'orgINN',
    'orgOGRN',
    'auditory',
    'advantages',
    'businessModel',
    'websites',
    'stage',
    'resursObesp',
    'whereAprob',
    'asiGoals',
    'asiGoalLeaderComment',
    'socialEffect',
    'marketAnalysis',
    'partners',
    'nationalTargets',
    'nationalProjects',
    'potential',
    'organizationWebsite',
]);

export const presetFields: IPresetFields[] = [
    {
        presetName: 'Лидерские проекты',
        color: '#5cc51b',
        fields: new Set([
            'projectName',
            'auditory',
            'goals',
            'description',
            'advantages',
            'businessModel',
            'websites',
            'stage',
            'resursObesp',
            'whereAprob',
            'orgShortName',
            'orgINN',
            'orgLegalAddress',
            'asiGoals',
            'leaderEmail',
            'socialEffect',
            'marketAnalysis',
            'partners',
            'nationalTargets',
            'nationalProjects',
            'potential',
            'organizationWebsite',
        ]),
    },
    {
        presetName: 'Витрина',
        color: '#1bc5c5',
        fields: fieldsInShowcase,
        forPassport: true
    },
    {
        presetName: 'Паспортные',
        color: '#c5571b',
        fields: new Set(passportFields),
        forPassport: true
    }
];
